import Vue from 'vue';
import VueRouter from 'vue-router';

import OrderMasterIndex from './views/orderMaster/Index.vue';
import OrderMasterOrder from './views/orderMaster/Order.vue';
import OrderMasterDetail from './views/orderMaster/Detail.vue';
import CoinMasterOrder from './views/mideCoinOrder/Order.vue';
import CoinMasterDetail from './views/mideCoinOrder/Detail.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/order-masters/:orderMasterUuid',
        name: 'OrderMasterIndex',
        component: OrderMasterIndex,
        meta: {
            title: '米德交费中心',
            description: '交费简介及查询',
        },
    },
    {
        path: '/order-masters/:orderMasterUuid/orders/students/:studentUuid',
        name: 'OrderMasterOrder',
        component: OrderMasterOrder,
        meta: {
            title: '交费',
            description: '订单及交费',
        },
    },
    {
        path: '/order-masters/:orderMasterUuid/detail',
        name: 'OrderMasterDetail',
        component: OrderMasterDetail,
        meta: {
            title: '交费详情',
            description: '资费结果及订单详情',
        },
    },
    {
        path: '/coin/master/order',
        name: 'CoinMasterOrder',
        component: CoinMasterOrder,
        meta: {
            title: '交费',
            description: '订单及交费',
        },
    },
    {
        path: '/coin/master/detail',
        name: 'CoinMasterDetail',
        component: CoinMasterDetail,
        meta: {
            title: '交费详情',
            description: '资费结果及订单详情',
        },
    },
];

const router = new VueRouter({
    routes,
});

router.beforeEach((to, from, next) => {
    window.document.title = to.meta.title;
    next();
});

export default router;
